import { render } from "./SeqDepth.vue?vue&type=template&id=739b9104"
import script from "./SeqDepth.vue?vue&type=script&lang=js"
export * from "./SeqDepth.vue?vue&type=script&lang=js"

import exportComponent from "/browser/CARTaGENE_vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__